import { useLocation } from "react-router";
import type { LinkProps } from "react-router";

export function usePreserveQuery() {
  const location = useLocation();
  return (to: LinkProps["to"], extraParams?: Record<string, string>) => {
    let search = location.search || "";
    if (extraParams) {
      const params = new URLSearchParams(search);
      for (const [key, value] of Object.entries(extraParams)) params.set(key, value);
      search = `?${params.toString()}`;
    }
    if (typeof to === "string") return { pathname: to, search };
    return { ...to, search: to.search ?? search };
  };
}
